import React, { Fragment } from 'react';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import ClickLayer from '../../../ClickLayer/ClickLayer.js';
import Icon from '../../styledComponents/Icon.js';
import Button from '../Button/Button.js';

import { IDropdownConfiguration, IDropdownProps, IDropdownState } from './models/index.js';
import { DROPDOWN_CATEGORY_KEY, DROPDOWN_COMPONENT_KEY, DROPDOWN_PARENT_COMPONENT_KEY } from './Dropdown.meta.js';

export class Dropdown extends ComponentBase<IDropdownProps, IDropdownState, IDropdownConfiguration> {
	categoryKey = DROPDOWN_CATEGORY_KEY;
	componentKey = DROPDOWN_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return DROPDOWN_PARENT_COMPONENT_KEY;
	}

	constructor(props: IDropdownProps) {
		super(props);
	}

	render() {
		const { children, buttonProps, contextMenuLabel, asset, toggleDropdown, open, iconAlt, hideAsset, className } =
			this.props;

		return (
			<div className={className}>
				<Button {...buttonProps}>
					{contextMenuLabel}
					{!hideAsset && <Icon alt={iconAlt || 'Context Menu Icon'} asset={asset} />}
				</Button>
				{open && (
					<Fragment>
						<ClickLayer onClick={toggleDropdown} />
						{children}
					</Fragment>
				)}
			</div>
		);
	}
}

export default InjectedStyledComponent(observer(Dropdown), DROPDOWN_CATEGORY_KEY, DROPDOWN_PARENT_COMPONENT_KEY, [
	DROPDOWN_COMPONENT_KEY,
]);
